<script lang="ts" setup>
/**
 * This component is used for displaying text values. Mostly in the grid.
 * It can also be used to display translations and to create translation keys
 * If viewparams is set we will wrap the text in a router-link
 */
import { $tm } from '@/locize';
import { type RouteName } from '@/objects/Router';
import { ref } from 'vue';
import { RouterLink } from '@/components';

const props = withDefaults(
    defineProps<{
        /**
         * Can be a string or a translation key
         */
        value: string | null;

        /**
         * If set, we will prefix the value with this translation key separated by a . and all in lowercase
         * This will create a
         */
        translationprefix?: string | null;

        /**
         * The name of the route to navigate to
         */
        routename: RouteName | null;

        /**
         * The eventId to push to the router
         */
        eventId?: number;

        /**
         * If set, we will display the text as deleted
         */
        deleted?: boolean;
    }>(),
    { value: null, routename: null },
);

// The internal text value
const text = ref<string | null>(null);

const emit = defineEmits<{
    (e: 'click'): void;
}>();

// Check if we should create a translation key
if (props.translationprefix != null && props.translationprefix.length > 0) {
    text.value = (props.translationprefix + '.' + props.value).toLocaleLowerCase();
} else {
    text.value = props.value ?? '';
}
</script>

<template>
    <div class="field-renderer-text">
        <template v-if="routename">
            <span
                :style="{
                    'text-decoration': deleted ? 'line-through' : 'none',
                    color: deleted ? '#ff000099' : 'unset',
                }"
            >
                <span
                    ><RouterLink
                        :route="routename"
                        :eventID="eventId"
                        >{{ $tm(text ?? '') }}</RouterLink
                    ></span
                >
            </span>
        </template>
        <template v-else>
            <span>
                <span>{{ $tm(text ?? '') }}</span>
            </span>
        </template>
    </div>
</template>
